import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=537d4da0&scoped=true&"
import script from "./base_info.vue?vue&type=script&lang=js&"
export * from "./base_info.vue?vue&type=script&lang=js&"
import style0 from "./base_info.vue?vue&type=style&index=0&id=537d4da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d4da0",
  null
  
)

export default component.exports